import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import GreetingMembershipsPage from "./greeting-memberships-page";
import GreetingMembershipCreatePage from "./greeting-membership-create-page";
import GreetingMembershipEditPage from "./greeting-membership-edit-page";

export default (
  <Route path="greeting-memberships">
    <Route
      index
      element={
        <Protected
          path="/admin/greeting-memberships"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <GreetingMembershipsPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/greeting-memberships/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <GreetingMembershipCreatePage />
        </Protected>
      }
    />

    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/greeting-memberships/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <GreetingMembershipEditPage />
        </Protected>
      }
    />
  </Route>
);
